import Data from '../Api/Data'
import PrimaryKey from '../Api/PrimaryKey'
import { Type } from 'class-transformer'
import TK2UserLookupDM from './TK2UserLookupDM'
import TQueueItemDM from './TQueueItemDM'

export default class TWMSQueueDM extends Data {
	public static className = 'TWMSQueueDM'
	public static primaryKey = 'Id'
	public static systemFields = [
		'TimeStamp',
	]

	public getPrimaryKey(): PrimaryKey {
		return this.Id!
	}

	CreatedOn?: Date
	TimeStamp?: string
	RightGroupId?: number
	LastSequenceNo?: number
	ChangedOn?: Date
	Description?: string
	Id?: number
	Name?: string
	Abbr?: string
	SelectionImgCalc?: string
	LegislationContextCalc?: number
	CurrentDateCalc?: Date
	CurrentTimeCalc?: Date
	SequenceUpdateDisableBitCalc?: number
	RightGroupIdCalc?: number
	@Type(() => TK2UserLookupDM)
	CreatedById?: TK2UserLookupDM
	@Type(() => TK2UserLookupDM)
	ChangedById?: TK2UserLookupDM
	@Type(() => TQueueItemDM)
	ItemChild?: TQueueItemDM[]
}